var _style, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97 97",
    style: {
      enableBackground: "new 0 0 97 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{opacity:0.55;fill:url(#SVGID_00000119839224838521529500000011391589069499951262_);}\r\n\t.st2{opacity:0.55;fill:url(#SVGID_00000120543841972717395970000006533349915163293370_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.07830922,
    y1: 48.5,
    x2: 97.0783,
    y2: 48.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AC7BB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09822953,
    style: {
      stopColor: "#A477AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6987,
    style: {
      stopColor: "#7660A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6457A0"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.5,
    cy: 48.5,
    r: 48.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095299414172644762560000010838586435797083568_",
    gradientUnits: "userSpaceOnUse",
    x1: -690.9246,
    y1: 664.7939,
    x2: -614.1235,
    y2: 664.7939,
    gradientTransform: "matrix(-0.4174 -0.4174 -0.7071 0.7071 242.6062 -684.4058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000095299414172644762560000010838586435797083568_)"
    },
    d: "M28.9,56L47,74.1 c3.8,3.8,10.1,3.8,14,0l0,0c3.8-3.8,3.8-10.1,0-14L42.8,42c-3.8-3.8-10.1-3.8-14,0l0,0C25,45.9,25,52.2,28.9,56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104678472408771217800000008754016541181565858_",
    gradientUnits: "userSpaceOnUse",
    x1: -2603.1648,
    y1: 1793.657,
    x2: -2526.3638,
    y2: 1793.657,
    gradientTransform: "matrix(-0.4174 0.4174 -0.7071 -0.7071 242.6062 2378.6887)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#EBE8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDF3F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000104678472408771217800000008754016541181565858_)"
    },
    d: "M28.9,41.8L47,23.7 c3.8-3.8,10.1-3.8,14,0l0,0c3.8,3.8,3.8,10.1,0,14L42.8,55.8c-3.8,3.8-10.1,3.8-14,0l0,0C25,52,25,45.7,28.9,41.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStage1);
export default __webpack_public_path__ + "static/media/Play_stage1.32d214a928b80c052153037271db0c9e.svg";
export { ForwardRef as ReactComponent };